import React, { useState, useEffect } from "react";
import moment from "moment";
import "./Chatbot.css";
import { sbaAxios } from "../utils/sbaAxios";
import { removeFavoritePrompt,updateFavPromptSortOrder } from "../../config/apiConfig";
import { SBNotify } from "../utils/sbNotify";
import { Modal } from "react-bootstrap";

const SortableItem = ({ dataItem, index, onRemove, onItemClick, onDragStart, onDragOver, onDrop }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="menu-item recent-item p-2"
      draggable
      onDragStart={(e) => onDragStart(e, index)}
      onDragOver={(e) => onDragOver(e, index)}
      onDrop={onDrop}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="d-flex" style={{ cursor: "pointer" }}>
        <p
          style={{
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            marginBottom: 0,
          }}
          onClick={() => onItemClick(dataItem.Prompt)}
          title={dataItem.Prompt}
        >
          {dataItem.Prompt}
        </p>
        {isHovered && !dataItem.IsShared && (
          <i
            className="fa-solid fa-trash text-danger row-items ms-2"
            title="Remove from Favorite"
            onMouseDown={(event) => event.stopPropagation()}
            onClick={() => onRemove(dataItem)}
          ></i>
        )}
      </div>
    </div>
  );
};

function FavoritePrompts({ favprompts, setInputText, handleFavoriteRemove, setIsReOrdered, setIsReload }) {
  const [favoriteList, setFavoriteList] = useState([]);
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [draggedItemIndex, setDraggedItemIndex] = useState(null);

  useEffect(() => {
    setFavoriteList(favprompts);
  }, [favprompts]);

  const removeFromFavorite = (prompt) => {
    setSelectedPrompt(prompt);
    setShowDeleteModal(true);
  };

  const deleteFromFavorite = async () => {
    if (selectedPrompt?.FavouritePromptId) {
      await sbaAxios({
        url: removeFavoritePrompt + selectedPrompt.FavouritePromptId,
        method: "post",
      }).then(() => {
        setSelectedPrompt(null);
        setShowDeleteModal(false);
        handleFavoriteRemove();
        setIsReload(true);
      });
      setTimeout(() => setIsReload(false), 500);
    }
  };

  // Handle Drag & Drop Sorting
  const onDragStart = (e, index) => {
    setDraggedItemIndex(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const onDragOver = (e, index) => {
    e.preventDefault();
    if (draggedItemIndex === index) return;
    const newList = [...favoriteList];
    const draggedItem = newList[draggedItemIndex];
    newList.splice(draggedItemIndex, 1);
    newList.splice(index, 0, draggedItem);

    setDraggedItemIndex(index);
    setFavoriteList(newList);
  };

  const onDrop = async () => {
    const updatedList = favoriteList.map((item, index) => ({
      ...item,
      sortOrder: index + 1,
    }));
    setFavoriteList(updatedList);

    // Update backend with new order
    await sbaAxios({
      url: updateFavPromptSortOrder,
      method: "post",
      data: updatedList,
    });

    setIsReOrdered(true);
    setTimeout(() => setIsReOrdered(false), 500);
  };

  return (
    <div style={{ height:"50vh", overflowY:"scroll"}}>
      <ul className="recent-list p-0">
        {favoriteList.map((item, index) => (
          <SortableItem
            key={item.FavouritePromptId}
            dataItem={item}
            index={index}
            onRemove={removeFromFavorite}
            onItemClick={setInputText}
            onDragStart={onDragStart}
            onDragOver={onDragOver}
            onDrop={onDrop}
          />
        ))}
      </ul>

      <Modal show={showDeleteModal}>
        <Modal.Header closeButton onClick={() => setShowDeleteModal(false)}>
          <Modal.Title>Remove Favorite?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Prompt will be deleted permanently. Are you sure?</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="s-sm-btn mx-1" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </button>
          <button className="p-sm-btn mx-1" onClick={deleteFromFavorite}>
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default FavoritePrompts;
